import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_NHSV_SECURITIES_PRICE_API_ID =
  'DASHBOARD/FETCH_NHSV_SECURITIES_PRICE_API';

const apiCall = createApiCall(
  FETCH_NHSV_SECURITIES_PRICE_API_ID,
  (params: { symbols: string }) => ({
    endpoint: generateEndpoint({
      host: '/api/admin/nhsv/securities-price',
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
